import React from 'react';
import PropTypes from 'prop-types';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import CssBaseline from '@material-ui/core/CssBaseline';
import useScrollTrigger from '@material-ui/core/useScrollTrigger';
import Box from '@material-ui/core/Box';
import Container from '@material-ui/core/Container';
import Slide from '@material-ui/core/Slide';

function HideOnScroll(props) {
  const { children, window, triggered } = props;
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({ target: window ? window() : undefined });

  return (
    triggered ? (
      <Slide appear direction="down" in={triggered} style={{ marginTop: '64px' }}>
        {children}
      </Slide>
    ) : <></>
  );
}

HideOnScroll.propTypes = {
  children: PropTypes.element.isRequired,
  /**
   * Injected by the documentation to work in an iframe.
   * You won't need it on your project.
   */
  window: PropTypes.func,
};

export default function HideAppBar(props) {
  const {
    title, href, backgroundcolor, triggered,
  } = props;
  return (
    <>
      <CssBaseline />
      <HideOnScroll {...props}>
        <AppBar style={{
          backgroundColor: backgroundcolor,
          transition: 'background-color 1s linear',
          alignItems: 'right',
          paddingRight: '56px',
          zIndex: 1,
        }}
        >
          <Toolbar>
            <div
              variant="h6"
              style={{
                fontSize: '2rem',
                minHeight: '64px',
                display: 'flex',
                alignItems: 'center',
                paddingRight: '106px',
                fontFamily: 'Almarai',
              }}
            >
              <a href={`#${href}`} style={{ color: 'white' }}>{title}</a>
            </div>
          </Toolbar>
        </AppBar>
      </HideOnScroll>
      <Toolbar />
    </>
  );
}
